import React, { useMemo } from 'react';

import StatCard from '../../common/StatCard/StatCard';
import usePrometheusQuery from '../../../utils/hooks/use_prometheus_query_without_range';
import { percentFormatter } from '../../../utils/formatters';
import Icon from '../../common/icons/Icon';
import COLORS from '../../../constants/colors.constants';
import LogStorageIcon from '../../common/icons/LogStorageIcon';
import { formatUnitRatioForStorage } from '../../../utils/prometheus_utils';

const getUsedInferenceLogStorage = () => {
  return 'kubelet_volume_stats_used_bytes{persistentvolumeclaim="plateau-managed-disk"}';
}

const getTotalInferenceLogStorage = () => {
  return 'kubelet_volume_stats_capacity_bytes{persistentvolumeclaim="plateau-managed-disk"}'
}

export const useTotalLogStorage = () => {
  const query = useMemo(() => {
    return getTotalInferenceLogStorage();
  }, [])
  const prometheusResponse = usePrometheusQuery(query);

  return {
    chartData: prometheusResponse?.data,
    isLoading: prometheusResponse?.isLoading,
    message: prometheusResponse?.error || null,
  }
}

export const useRequestedInferenceLogStorage = () => {
  const query = useMemo(() => {
    return getUsedInferenceLogStorage();
  }, [])
  const prometheusResponse = usePrometheusQuery(query);

  return {
    chartData: prometheusResponse?.data,
    isLoading: prometheusResponse?.isLoading,
    message: prometheusResponse?.error || null,
  }
}

const LogStorageIconComponent = () => {
  return <Icon fill={COLORS.brand} icon={LogStorageIcon} size={24} useTailwindSizing />
}

export const ContextualLogStorageCard = () => {
  const requestedResponse = useRequestedInferenceLogStorage()
  const requestedData = requestedResponse?.chartData;
  const requestedValue = requestedData?.length ? requestedData[1] : 0;

  const totalResponse = useTotalLogStorage()
  const totalData = totalResponse?.chartData;
  const totalValue = totalData?.length ? totalData[1] : 0;

  const subVal = formatUnitRatioForStorage(requestedValue, totalValue);
  const subtitle = `Used ${subVal} Allocated`;

  const content = totalValue ? percentFormatter.format(requestedValue/totalValue) : 0;
  const isLoading = requestedResponse?.isLoading || totalResponse?.isLoading;

  return (
    <StatCard
      className=""
      icon={LogStorageIconComponent}
      header="Total Inference Log Storage"
      subtitle={subtitle}
      content={`${content}`}
      isLoading={isLoading}
    />
  )
}

export default ContextualLogStorageCard;
